import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=09ccc182&scoped=true&"
import script from "./doctorInfo.vue?vue&type=script&lang=js&"
export * from "./doctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=09ccc182&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ccc182",
  null
  
)

export default component.exports